module.exports = __webpack_public_path__ + "static/media/ot-src.9de7f75e.svg";